// @flow

import React from 'react';
import { Menu, Icon } from 'semantic-ui-react';
import ResourcesPager from './ResourcesPager';
import FoldersFilter from './FoldersFilter';
import DebounceInput from 'react-debounce-input';

type Props = {
  folders: List<BucketFolder>,
  hasPreviousPage: boolean,
  hasNextPage: boolean,
  onPreviousPage: () => void,
  onNextPage: () => void,
  currentFolder?: number,
  onFolderChange: (folder: number) => void,
  currentFilter: string,
  onFilterChange: (filter: string) => void,
};

const ResourcesHeader = ({
  folders,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  currentFolder,
  onFolderChange,
  currentFilter,
  onFilterChange,
}: Props) => {
  const changeFilter = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onFilterChange(event.target.value);
    } else {
      onFilterChange('');
    }
  };

  return (
    <Menu>
      <Menu.Item>
        <div className="ui icon input">
          <DebounceInput
            autoFocus
            minLength={2}
            debounceTimeout={600}
            value={currentFilter}
            onChange={changeFilter}
            placeholder="Recherche..."
          />
          <Icon name="search" />
        </div>
      </Menu.Item>
      <Menu.Item>
        <FoldersFilter
          value={currentFolder}
          folders={folders}
          onChange={onFolderChange}
        />
      </Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>
          <ResourcesPager
            hasPrevious={hasPreviousPage}
            hasNext={hasNextPage}
            onPrevious={onPreviousPage}
            onNext={onNextPage}
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};

export default ResourcesHeader;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/ResourcesHeader.js